module.exports = __webpack_public_path__ + "static/varun-19254e904a3596542771c38853d551fe.jpg";